import { render, staticRenderFns } from "./settingGutter.vue?vue&type=template&id=47aba5f5&scoped=true"
import script from "./settingGutter.vue?vue&type=script&lang=js"
export * from "./settingGutter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aba5f5",
  null
  
)

export default component.exports